module.exports = __webpack_public_path__ + "static/media/checkbox-large-on.f6aa1ced.svg";